import script from "./corporate-news-list.vue?vue&type=script&lang=js"
export * from "./corporate-news-list.vue?vue&type=script&lang=js"

import "./corporate-news-list.vue?vue&type=style&index=0&id=bb22a056&lang=scss"

const __exports__ = script;

export default __exports__